import { render, staticRenderFns } from "./MoveJobList.vue?vue&type=template&id=3da2973a&scoped=true&"
import script from "./MoveJobList.vue?vue&type=script&lang=js&"
export * from "./MoveJobList.vue?vue&type=script&lang=js&"
import style0 from "./MoveJobList.vue?vue&type=style&index=0&id=3da2973a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da2973a",
  null
  
)

export default component.exports